module.exports = __webpack_public_path__ + "static/anthropologie-3eb425e17c400daa3e107bde2d7d36ea.svg";